module.exports = __webpack_public_path__ + "static/media/autodesk-logo-alternate-rgb-black-small.5b42fc4d.png";